import { ArrowLeft, CreditCard, Mail, FileText, Clock, AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import Footer from "@/components/landing/Footer";

export default function LicenciamentoRenovacoesPage() {
  const paymentLink = "https://mpago.la/2MkpBTx";

  return (
    <div className="min-h-screen bg-[#0F1115]" data-testid="licenciamento-page">
      {/* Header */}
      <header className="border-b border-[#2A2F38] bg-[#0F1115]/95 backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex items-center justify-between">
          <a href="/" className="flex items-center gap-2 text-[#9CA3AF] hover:text-[#E5E7EB] transition-colors">
            <ArrowLeft className="h-4 w-4" />
            <span className="text-sm">Voltar para Home</span>
          </a>
          <a href="/" className="font-heading text-xl font-bold">
            <span className="text-[#F59E0B]">Kp</span>
            <span className="text-[#E5E7EB]">Action</span>
          </a>
        </div>
      </header>

      {/* Main Content */}
      <main className="py-16 px-6">
        <div className="max-w-4xl mx-auto">
          
          {/* BLOCO 1 - Título */}
          <div className="text-center mb-16">
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-[#E5E7EB] mb-4">
              Licenciamento e <span className="text-[#F59E0B]">Renovações</span>
            </h1>
            <p className="text-[#9CA3AF] text-base md:text-lg max-w-2xl mx-auto">
              Nesta página você pode adquirir uma nova licença anual do KpAction ou renovar uma licença existente.
            </p>
          </div>

          {/* BLOCO 2 - Aquisição de Licença */}
          <section className="bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-8 md:p-10 mb-8" data-testid="aquisicao-section">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center bg-[#0E3A46] rounded-sm">
                <CreditCard className="h-5 w-5 text-[#F59E0B]" />
              </div>
              <h2 className="font-heading text-2xl font-bold text-[#E5E7EB]">
                Aquisição de Licença Anual
              </h2>
            </div>

            <div className="space-y-4 text-[#9CA3AF] mb-8">
              <p>
                A licença anual do KpAction pode ser adquirida diretamente a qualquer momento.
              </p>
              <p>
                Caso você já esteja utilizando o período de avaliação (trial), a conversão para licença anual pode ser realizada a qualquer momento durante o período de teste.
              </p>
              <p>
                Se a aquisição ocorrer dentro do período ativo de avaliação, sua licença será ativada por{" "}
                <span className="text-[#F59E0B] font-medium">13 meses</span>, em vez do período padrão de 12 meses.
              </p>
            </div>

            {/* Preço */}
            <div className="bg-[#0F1115] border border-[#F59E0B]/30 rounded-sm p-6 mb-8">
              <div className="text-center">
                <p className="text-sm text-[#9CA3AF] mb-2">Valor da Licença Anual</p>
                <p className="font-heading text-3xl md:text-4xl font-bold text-[#F59E0B] mb-2">
                  12x de R$ 499,99
                </p>
                <p className="text-[#6B7280]">ou R$ 4.913,46 à vista</p>
              </div>
            </div>

            {/* Botão de Pagamento */}
            <div className="text-center">
              <a
                href={paymentLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="payment-button"
              >
                <Button className="bg-[#F59E0B] text-black font-bold uppercase tracking-wide hover:bg-[#D97706] transition-all rounded-sm px-10 py-6 text-base shadow-glow hover:shadow-glow-strong">
                  <CreditCard className="mr-2 h-5 w-5" />
                  Realizar Pagamento
                </Button>
              </a>
            </div>
          </section>

          {/* BLOCO 3 - Instruções Após Pagamento */}
          <section className="bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-8 md:p-10 mb-8" data-testid="instrucoes-section">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center bg-[#0E3A46] rounded-sm">
                <Mail className="h-5 w-5 text-[#F59E0B]" />
              </div>
              <h2 className="font-heading text-2xl font-bold text-[#E5E7EB]">
                Após realizar o pagamento
              </h2>
            </div>

            <div className="space-y-4 text-[#9CA3AF]">
              <p>
                Após concluir o pagamento, envie um e-mail para:
              </p>
              
              <div className="bg-[#0F1115] border border-[#2A2F38] rounded-sm p-4 text-center">
                <a 
                  href="mailto:contato@kpaction.com.br" 
                  className="text-[#F59E0B] hover:text-[#FBBF24] transition-colors font-medium text-lg"
                >
                  contato@kpaction.com.br
                </a>
              </div>

              <p className="pt-4">Incluindo as seguintes informações:</p>
              
              <ul className="space-y-2 pl-4">
                <li className="flex items-start gap-2">
                  <span className="text-[#F59E0B] mt-1">•</span>
                  Nome da empresa
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#F59E0B] mt-1">•</span>
                  CNPJ
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#F59E0B] mt-1">•</span>
                  Nome do responsável
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#F59E0B] mt-1">•</span>
                  Comprovante de pagamento
                </li>
              </ul>

              <div className="bg-[#0E3A46]/30 border border-[#164E63] rounded-sm p-4 mt-6">
                <p className="text-[#E5E7EB]">
                  Se você já possui o executável instalado ou realizou o período de avaliação, inclua também:
                </p>
                <p className="text-[#F59E0B] font-medium mt-2">• Machine ID do software</p>
              </div>

              <p className="pt-4 text-[#E5E7EB]">
                Após a validação do pagamento enviaremos sua chave de ativação da licença.
              </p>
            </div>
          </section>

          {/* BLOCO 4 - Renovação de Licença */}
          <section className="bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-8 md:p-10 mb-8" data-testid="renovacao-section">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center bg-[#0E3A46] rounded-sm">
                <FileText className="h-5 w-5 text-[#F59E0B]" />
              </div>
              <h2 className="font-heading text-2xl font-bold text-[#E5E7EB]">
                Renovação de Licença
              </h2>
            </div>

            <div className="space-y-4 text-[#9CA3AF]">
              <p>
                Se sua licença anual expirou ou está próxima da expiração, você pode realizar a renovação normalmente.
              </p>
              <p>
                O processo de renovação utiliza o mesmo pagamento da licença anual.
              </p>
              <p>
                Após realizar o pagamento, envie um e-mail para:
              </p>

              <div className="bg-[#0F1115] border border-[#2A2F38] rounded-sm p-4 text-center">
                <a 
                  href="mailto:contato@kpaction.com.br" 
                  className="text-[#F59E0B] hover:text-[#FBBF24] transition-colors font-medium text-lg"
                >
                  contato@kpaction.com.br
                </a>
              </div>

              <p className="pt-4">Incluindo:</p>
              
              <ul className="space-y-2 pl-4">
                <li className="flex items-start gap-2">
                  <span className="text-[#F59E0B] mt-1">•</span>
                  Nome da empresa
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#F59E0B] mt-1">•</span>
                  CNPJ
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#F59E0B] mt-1">•</span>
                  Machine ID do software
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#F59E0B] mt-1">•</span>
                  Comprovante de pagamento
                </li>
              </ul>

              <p className="pt-4 text-[#E5E7EB]">
                Após a confirmação enviaremos a nova chave de ativação da licença.
              </p>
            </div>
          </section>

          {/* BLOCO 5 - Observação Promocional */}
          <section className="bg-[#0F1115] border border-[#2A2F38] rounded-sm p-6 md:p-8" data-testid="observacao-section">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-[#F59E0B]/10 rounded-sm">
                <Clock className="h-5 w-5 text-[#F59E0B]" />
              </div>
              <div>
                <h3 className="font-heading text-lg font-bold text-[#E5E7EB] mb-3">
                  Observação sobre o período promocional
                </h3>
                <p className="text-[#9CA3AF] text-sm leading-relaxed">
                  A extensão promocional do período licenciado (13 meses) é válida apenas para conversões realizadas dentro do período ativo de avaliação.
                </p>
                <p className="text-[#9CA3AF] text-sm leading-relaxed mt-3">
                  Aquisições realizadas após o término do período de teste ou renovações de licença seguem o período padrão de{" "}
                  <span className="text-[#E5E7EB]">12 meses</span> de licenciamento.
                </p>
              </div>
            </div>
          </section>

        </div>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}
